<div class="user-profile__card">
    <div class="row">
       <div class="col-md-6">

            <div class="profile-cover" *ngIf="user">
                <div class="user-profile-avatar">
                    <img *ngIf="!user.image_url && !userImage" src="assets/images/avatars/profile-avatar.png"
                        class="img-fluid user-profile__img" alt="user-profile">

                    <img *ngIf="user.image_url || userImage"
                        [src]="user.image_url || 'assets/images/avatars/profile-avatar.png'"
                        class="img-fluid user-profile__img" alt="user-profile">

                    <div class="camera-icon" *ngIf="isAllowEdit() && isImageChange && !inProcessing">
                        <img src="assets/images/icons/Camaraicon.png" alt="Camaraicon" (click)="triggerFileInput()">
                        <input type="file" id="ImageInput" accept="image/*" (change)="onFrontFileSelected($event)"
                            hidden>
                    </div>
                </div>


                <h1 class="Profile-userFullName">
                    {{user?.display_name}}
                </h1>
                <p class="Profile-userlocation" *ngIf="user?.city">
                    {{user?.city}},{{user?.state}}
                </p>



                <!-- <div class="profileCard-editButton" (click)="isImageChange = true"
                    *ngIf="user && isAllowEdit() && !isImageChange && !inProcessing">
                    <button class="edit-btn">Change Image</button>
                </div>

                <div class="profileCard-editButton" (click)="updateProfileImage()"
                    *ngIf="orignalImage && !inProcessing">
                    <button class="edit-btn">Save Image</button>
                </div> -->
            </div>
        </div> 
        <div class="col-md-6 ">
            <div class="profile-card__userDetails">
                <h3 class="Profile-occupation">
                    {{user?.subscription?.package_title}}
                </h3>
                <p class="profile-coins__info">
                    Member Since <span>{{user?.created_at | date }}</span>
                </p>
                <p class="profile-coins__info">
                    Coins in Collection <span> {{totalCoins}}</span>
                </p>
                <p class="profile-coins__info">
                    Coins Assessed <span>{{totalAssess}}</span>
                </p>
            </div>
            <div class="profileCard-editButton" *ngIf="user && isAllowEdit()">
                <button class="edit-btn" [routerLink]="['/user/profile/edit']"> <i
                        class="fas fa-pencil-alt m-r-8 edit-pencil"></i>Edit Profile</button>
            </div>

        </div>
        <div class="col-12 text-center" *ngIf="user && user?.subscription?.stripe_status == pauseStatus">
            <h2 class="text-center show-sub-message">Your subscription is currently paused but remains active until <span> {{user?.subscription?.expires_at | date}}</span></h2>
        </div>
            <div class="member-ship-container mt-3 text-center" *ngIf="user && isFreeUser()">
                    <button
                      type="button"
                      class="edit-btn edit-btn-update upgrade-plan-btn"
                      (click)="manageMemberShip()"
                    >
                      <i class="fas fa-crown me-2" aria-hidden="true"></i> Upgrade Plan
                    </button>
                    <p class="upgrade-plan-copy">Unlock more uploads and advanced collection tools.</p>
                  </div>
    </div>

</div>
